'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FitImage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _img = require('./img');

var _img2 = _interopRequireDefault(_img);

var _mask = require('./mask');

var _mask2 = _interopRequireDefault(_mask);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Class for image.
 * It loads an image as a background-image. The original image is still
 * rendered for accessibility reasons.
 * @public
 * @class MaskedImage
 * @param {Object} props
 *   The properties
 * @param {(String|Array)} [props.mixin]
 * @param {String} [props.className]
 * @param {String} props.alt
 * @param {String} props.src
 * @param {?String} props.title
 */
var MaskedImage = function (_Component) {
  _inherits(MaskedImage, _Component);

  _createClass(MaskedImage, null, [{
    key: 'propTypes',


    /**
     * @private
     */
    get: function get() {
      return {
        mixin: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string]),
        className: _propTypes2.default.string,
        alt: _propTypes2.default.string.isRequired,
        src: _propTypes2.default.string.isRequired,
        title: _propTypes2.default.string
      };
    }

    /**
     * @private
     */

    /**
     * @private
     */

  }, {
    key: 'defaultProps',
    get: function get() {
      return {
        title: '',
        mixin: '',
        className: ''
      };
    }

    /**
     * Constructs the object.
     * @public
     * @param {Object} props
     *   The properties
     * @param {(String|Array)} [props.mixin]
     * @param {String} [props.className]
     * @param {String} props.alt
     * @param {String} props.src
     * @param {?String} [props.title]
     */

  }]);

  function MaskedImage(props) {
    _classCallCheck(this, MaskedImage);

    var _this = _possibleConstructorReturn(this, (MaskedImage.__proto__ || Object.getPrototypeOf(MaskedImage)).call(this, props));

    _this.state = {};

    _this.getImage = _this.getImage.bind(_this);
    _this.handleLoad = _this.handleLoad.bind(_this);
    return _this;
  }

  /**
   * Handles the load event of the image.
   * @private
   */


  _createClass(MaskedImage, [{
    key: 'handleLoad',
    value: function handleLoad() {
      this.setState({
        height: this.image.height,
        width: this.image.width
      });
    }

    /**
     * Additional CSS rules for the mask
     * @private
     * @return {String|Array}
     */

  }, {
    key: 'getImage',


    /**
     * Assigns the image to `ref`.
     * @private
     * @param {ReactElement} el
     */
    value: function getImage(el) {
      /**
       * @private
       */
      this.image = el;
    }

    /**
     * @private
     * @return {Mask}
     *   An image nested inside a mask
     */

  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _mask2.default,
        {
          mixin: this.props.mixin,
          imageData: this.imageData,
          className: this.props.className },
        _react2.default.createElement(_img2.default, {
          innerRef: this.getImage,
          src: this.props.src,
          alt: this.props.alt,
          title: this.props.title,
          onLoad: this.handleLoad
        })
      );
    }
  }, {
    key: 'imageData',
    get: function get() {
      return '\n      --original-height: ' + this.state.height + 'px;\n      --original-width: ' + this.state.width + 'px;\n      background-image: url("' + this.props.src + '");\n    ';
    }
  }]);

  return MaskedImage;
}(_react.Component);

exports.default = MaskedImage;

/**
 * A version of `MaskedImage` that fits into its parent using
 * height/width 100%/100%
 * @param {Object} props
 *   The properties
 * @param {(String|Array)} [props.mixin]
 * @param {String} [props.className]
 * @param {String} props.alt
 * @param {String} props.src
 * @param {?String} props.title
 */

var FitImage = exports.FitImage = (0, _styledComponents2.default)(MaskedImage).withConfig({
  displayName: 'src__FitImage'
})(['--height:100%;--width:100%;']);
/**
 * @private
 */
FitImage.propTypes = {
  mixin: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string]),
  className: _propTypes2.default.string,
  alt: _propTypes2.default.string.isRequired,
  src: _propTypes2.default.string.isRequired,
  title: _propTypes2.default.string
};
//# sourceMappingURL=index.js.map